<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Loyal to the Sky</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="titlepage" id="d14e36">
<h1 id="d7e204">Loyal to the Sky</h1>
<p id="d7e254">Notes from an Activist<br/><br/></p>
<h2 id="d7e304"><b>MARISA HANDLER</b><br/><br/><br/></h2>
<div class="image">
<img alt="9781576759745_0004_001" src="images/9781576759745_0004_001.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?78624392